import type { BrandedFaresResponse } from '@/app/api/hotel-detail/branded-fares/route.ts';
import type { InitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';
import { getOpenTelemetryTraceIdFromTraceparent } from '@/utils/traceIdUtils.ts';

export const BRANDED_FARES_SHOWN = 'BRANDED_FARES_SHOWN';
export const BRANDED_FARES_SHOWN_VERSION = '1.1';

export type BrandedFaresShownPayload = {
  searchId: string;
  productDetailKey: string;
  flightClickId: string;
  brandedFareNameList: string;
  brandedFarePriceList: string;
  brandedFareCurrency: string;
  defaultBrandedFareName: string;
  brandedFareQty: number;
  traceId: string;
};

export type BrandedFaresShownParams = {
  initialParams: Pick<InitialParams, 'hdpSearchId' | 'productDetailKey' | 'flightClickId'>;
  brandedFaresData: BrandedFaresResponse | null | undefined;
  selectedMealPlan: MealPlanType | undefined;
  currency: string;
  searchTraceParent: string | undefined;
  // Fare id to prioritize as the "default" fare in the payload (typically the URL param
  // brandedFareId, falling back to the currently selected fare) — computed by the caller
  // because it depends on state (URL param / selection) outside this pure builder.
  targetFareId: string | undefined;
};

export const createBrandedFaresShownPayload = ({
  initialParams,
  brandedFaresData,
  selectedMealPlan,
  currency,
  searchTraceParent,
  targetFareId,
}: BrandedFaresShownParams): BrandedFaresShownPayload => {
  const fares = brandedFaresData?.fares ?? [];
  const preSelectedBrandedFare = fares.find((brandedFare) => brandedFare.fareId === targetFareId) || fares[0];

  return {
    searchId: initialParams.hdpSearchId,
    productDetailKey: initialParams.productDetailKey,
    flightClickId: initialParams.flightClickId || '',
    brandedFareNameList: fares.map((brandedFare) => brandedFare.fareId).join('-'),
    brandedFarePriceList: fares
      .map((brandedFare) => ((selectedMealPlan?.finalTotalPrice ?? 0) + brandedFare.priceDifference).toFixed(2))
      .join('-'),
    brandedFareCurrency: currency,
    defaultBrandedFareName: preSelectedBrandedFare?.fareId || '',
    brandedFareQty: fares.length,
    traceId: searchTraceParent ? getOpenTelemetryTraceIdFromTraceparent(searchTraceParent) : '',
  };
};
